<main>
    <app-header></app-header>
    <router-outlet></router-outlet>
</main>

@if (!isBackoffice) {
    <dynamic-xyz-daemon></dynamic-xyz-daemon>
}

<modal-anchor></modal-anchor>
<flash-messages-anchor></flash-messages-anchor>
<app-updates></app-updates>
